import Vue from "vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  notificationIntervalId: null,
  //url: "https://lumenarkitekter.se/api/",
  url: "/api/",
  viewPortTimeout: null,

  GetSeoStr(name) {
    return name
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase()
      .replace(/&/g, "-and-")
      .replace(/[^a-z0-9\-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-*/, "")
      .replace(/-*$/, "");
  },

  CheckViewPort(tag) {
    return new Promise((resolve) => {
      if (this.viewPortTimeout) {
        clearTimeout(this.viewPortTimeout);
      }

      this.viewPortTimeout = setTimeout(() => {
        let bounding;
        let el = document.getElementById(tag);
        if (el) {
          bounding = el.getBoundingClientRect();

          if (
            bounding.top <
              (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.bottom > 0
          ) {
            resolve(true);
          }

          resolve(false);
        }
      }, 50);
    });
  },

  GetAuthInfo() {
    let user = Vue.ls.get("user");
    let role = Vue.ls.get("role");

    if (user && role) {
      store.state.auth.user = user;
      store.state.auth.role = role;
      store.state.auth.success = true;
    }
  },

  Validate(arr) {
    let invalid = arr.find((item) => !item.valid);

    if (!invalid) {
      return true;
    } else {
      return false;
    }
  },

  ShowNotification(text, css, timeout) {
    store.state.notification.show = true;
    store.state.notification.css = "is-primary animated fadeInUp faster";
    store.state.notification.text = text;

    if (css) {
      store.state.notification.css = `is-${css} animated fadeInUp faster`;
    }

    if (this.notificationIntervalId) {
      clearInterval(this.notificationIntervalId);
    }

    if (timeout) {
      store.state.notification.timeout = timeout;

      this.notificationIntervalId = setInterval(() => {
        store.state.notification.timeout =
          store.state.notification.timeout - 1000;
        if (store.state.notification.timeout <= 0) {
          store.state.notification.css += "animated fadeOutDown faster ";
          //store.state.notification.show = false;
          clearInterval(this.notificationIntervalId);
          this.notificationIntervalId = null;
        }
      }, 1000);
    } else {
      this.notificationIntervalId = null;
      store.state.notification.timeout = null;
    }
  },

  GetBool(val) {
    if (val) {
      return !!JSON.parse(String(val).toLowerCase());
    }

    return false;
  },

  Filter(items, filter) {
    items = items.filter((item) => {
      return this.DoesObjMatch(item, filter);
    });

    return items;
  },

  SetItem(item, items, filter) {
    var index = this.GetIndex(items, filter);
    Vue.set(items, index, item);
    return items;
  },

  RemoveItem(item, items, filter) {
    var index = this.GetIndex(items, filter);
    items.splice(index);
    return items;
  },

  GetIndex(items, filter) {
    for (let [index, item] of items.entries()) {
      if (this.DoesObjMatch(item, filter)) {
        return index;
      }
    }

    return -1;
  },

  CopyItem(item) {
    return JSON.parse(JSON.stringify(item));
  },

  DoesObjMatch(item, filter) {
    item = Object.assign({}, item);

    for (let prop in filter) {
      if (!item[prop] && !filter[prop]) {
        return true;
      } else if (!item[prop] && filter[prop]) {
        return false;
      }

      //console.log(item[prop]);

      if (
        typeof item[prop] !== "string" &&
        Object.getOwnPropertyNames(item[prop]).length != 0
      ) {
        return this.DoesObjMatch(item[prop], filter[prop]);
      } else {
        // console.log(filter[prop]);
        // console.log(item[prop]);

        if (typeof item[prop] === "string") {
          item[prop] = item[prop].toLowerCase();
        }

        if (typeof filter[prop] === "string") {
          filter[prop] = filter[prop].toLowerCase();
        }

        if (typeof filter[prop] === "string" && filter[prop].includes("|")) {
          if (filter[prop].split("|").indexOf(item[prop]) !== -1) {
            return true;
          }

          return false;
        } else {
          return this.CheckFilter(item, filter, prop);
        }
      }
    }
  },
  CheckFilter(item, filter, prop) {
    if (filter[prop][0] == "!") {
      return this.CheckNotStrFilter(item, filter, prop);
    } else {
      return item[prop] === filter[prop] ? true : false;
    }
  },
  CheckNotStrFilter(item, filter, prop) {
    filter[prop] = filter[prop].replace("!", "");
    return item[prop] !== filter[prop] ? true : false;
  },

  GetProp(obj, propStr) {
    if (obj) {
      var arr = propStr.split(".");
      while (arr.length && (obj = obj[arr.shift()]));
      return obj;
    }

    return null;
  },

  DoesItemExist(item, items) {
    for (let currentItem of items) {
      if (currentItem.toLowerCase() == item.toLowerCase()) {
        return currentItem;
      }
    }

    return null;
  },

  Map(items, property) {
    if (items) {
      return items.map((item) => {
        return item[property];
      });
    }

    return [];
  },

  paging: {
    GetPageNumbers: (items) => {
      let numberArray = [];
      let total = items.length;

      if (total != 0) {
        let numbers = total / 10;

        let i;

        for (i = 0; i < numbers; i++) {
          numberArray.push((i + 1).toString());
        }
      } else {
        numberArray.push("1");
      }

      return numberArray;
    },

    GetPageStartIndex: (page) => {
      page = page - 1;
      let start = page * 10;
      return start;
    },
  },

  async ClearForm(form, newVal) {
    for (let input of form.inputs) {
      input.value = newVal;
    }
  },

  ClearStrings(obj) {
    for (let property in obj) {
      if (
        typeof obj[property] === "string" ||
        obj[property] instanceof String
      ) {
        obj[property] = null;
      } else if (typeof obj[property] === "object") {
        this.ClearStrings(obj[property]);
      }
    }

    return obj;
  },

  RemoveFromArray(items, filter) {
    var index = this.GetIndex(items, filter);
    items.splice(index, 1);
    return items;
  },

  ShowStatus(message, timeout, color) {
    this.ShowNotification(message, color, timeout);
  },

  GoTo(url) {
    router.push({
      path: url,
    });
  },

  async Logout(skipApiCall) {
    Vue.ls.clear();

    if (!skipApiCall) {
      await this.PostApi("logout", {});
    }

    store.state.auth.success = false;
    store.state.auth.user = {};
    store.state.auth.role = {};

    router.push({
      path: "/signin",
    });
  },

  GetFields(pageName = router.currentRoute.path) {
    return this.PostApi(
      "get/pageFields",
      {
        pageName: pageName,
      },
      true
    );
  },

  async GetPageFields(fields, pageName) {
    fields = { ...fields };
    for (let key in fields) {
      fields[key].name = key;
      fields[key].value = null;
    }

    let result = await this.GetFields(pageName);
    for (let x of result) {
      let obj = fields[x.name];
      if (obj && x.value) {
        obj.value = x.value;
      }
    }

    return fields;
  },

  GetField(pageName, fieldName) {
    if (!pageName) {
      pageName = router.currentRoute.path;
    }

    return this.PostApi("get/pageField", {
      pageName: pageName,
      fieldName: fieldName,
    });
  },

  SetField(pageName, fieldName, value) {
    if (!pageName) {
      pageName = router.currentRoute.path;
    }

    return this.PostApi("set/pageField", {
      pageName: pageName,
      fieldName: fieldName,
      value: value,
    });
  },

  async PostApi(path, data, skipAuth, onlyData = true) {
    return new Promise(async (resolve, reject) => {
      if (!skipAuth) {
        path = `secure/${path}`;
      }

      try {
        let res = await axios.post(this.url + path, {
          data: data,
        });

        if (onlyData) {
          resolve(res.data.data);
        }

        resolve(res);
      } catch (err) {
        console.log(err.response.status, 2);

        if (
          err.response.status === 401 &&
          router.currentRoute.path != "/logout"
        ) {
          this.Logout(true);
        } else if (err.response.status === 403) {
          this.ShowStatus(`Förfrågan (${path}) nekades`, 5000, "warning");
        }

        reject(err);
        //return err;
      }
    });
  },
};
